export default __webpack_public_path__ + "static/media/not_reportDesign.0422dfea.png";